var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#ED513C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.377 21.563l-6.72-10.854a3.125 3.125 0 00-5.314 0l-6.72 10.854a3.125 3.125 0 002.657 4.77h13.44a3.124 3.124 0 002.657-4.77zm-1.384 2.355a1.44 1.44 0 01-1.274.749H11.28a1.459 1.459 0 01-1.24-2.226l6.72-10.855a1.458 1.458 0 012.48 0l6.72 10.854a1.442 1.442 0 01.033 1.478z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.667 18h-1.862l1.743-2.905-1.43-.857-2.5 4.166a.832.832 0 00.715 1.262h1.862l-1.743 2.905 1.43.858 2.5-4.167A.833.833 0 0019.666 18z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/warning.71ae5d6195df91d135869dd71543c552.svg";
export { SvgWarning as ReactComponent };